module.exports = __webpack_public_path__ + "img/niue.bcc1d823.svg";